import React from 'react'
import './index.css'
import { Tooltip } from '@mui/material'


const imageLocation = (imagename) => `/images/${imagename}`

const LucketIcon = (props) => {
     
    return(<Tooltip title="Icon">
    <img className='LucketIcon' 
    src={imageLocation(props.icon||'A4-Context.svg')} 
    alt={props.icon}
    onClick={()=>{ 
        props.setEditing(  !props.editingIcon )}}
     />
     </Tooltip>
)}

export default LucketIcon